import * as React from 'react';

import Files140 from './Files140';

export const files140 = () => <Files140 />;

export default {
    title: 'Illustration/Files140',
    component: Files140,
    parameters: {
        notes: "`import Files140 from 'box-ui-elements/es/illustration/Files140';`",
    },
};
